

import React, { createContext, useState, useEffect } from "react";

export const GeoIPContext = createContext({
    country: null,
    loading: true,
});

const GEO_IP_KEY = "visitor_country_cache";
const GEO_IP_TTL = 4 * 60 * 60 * 1000; // 4 hours
const FALLBACK_COUNTRY = "FR";

export const GeoIPProvider = ({ children }) => {
    const [country, setCountry] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchGeo = async () => {
            try {
                const res = await fetch("https://ipapi.co/json/");
                const data = await res.json();
                if (data && data.country) {
                    const cacheData = {
                        country: data.country,
                        timestamp: Date.now(),
                    };
                    localStorage.setItem(GEO_IP_KEY, JSON.stringify(cacheData));
                    setCountry(data.country);
                } else {
                    setCountry(FALLBACK_COUNTRY);
                }
            } catch (err) {
                console.error("GeoIP fetch failed", err);
                setCountry(FALLBACK_COUNTRY);
            } finally {
                setLoading(false);
            }
        };

        const cache = localStorage.getItem(GEO_IP_KEY);
        if (cache) {
            try {
                const parsedCache = JSON.parse(cache);
                if (Date.now() - parsedCache.timestamp > GEO_IP_TTL) {
                    fetchGeo();
                } else {
                    setCountry(parsedCache.country || "US");
                    setLoading(false);
                }
            } catch (err) {
                console.error("Error parsing GeoIP cache, refetching.", err);
                fetchGeo();
            }
        } else {
            fetchGeo();
        }
    }, []);

    return (
        <GeoIPContext.Provider value={{ country, loading }}>
            {children}
        </GeoIPContext.Provider>
    );
};